import { extendTheme, type ThemeConfig, type ThemeOverride } from "@chakra-ui/react";

const config: ThemeConfig = { initialColorMode: "light", useSystemColorMode: false };

const extendedThemeConfig: ThemeOverride = { fonts: {}, components: {} };

const theme = extendTheme({ ...config, ...extendedThemeConfig });

export default theme;
